import { ThemeProvider } from "@mui/material/styles";
import i18next from "i18next";
import React from "react";
import { I18nextProvider } from "react-i18next";
import AppContent from "./components/entry/AppContent";
import appTheme from "./common/styles/appTheme";
import { SnackbarProvider } from "notistack";
import "./common/translations";
import { useInitCacheSettings } from "./components/printSettings/hooks/useInitCacheSettings";
import { useSafariViewPortReset } from "./common/hooks/useSafariViewPortReset/useSafariViewPortReset";
import { ODIN_LOGO_SWITCH_KEY, ODIN_START_PAGE_SWITCH_KEY } from "./common/constants";
import { notistackStyled } from "./common/styles/notistackStyled";

export default function App() {
  useInitCacheSettings([ODIN_LOGO_SWITCH_KEY, ODIN_START_PAGE_SWITCH_KEY]);
  useSafariViewPortReset();

  return (
    <ThemeProvider theme={appTheme}>
      <SnackbarProvider
        maxSnack={5}
        Components={{
          success: notistackStyled.StyledMaterialDesignContent,
          error: notistackStyled.StyledMaterialDesignContent,
          warning: notistackStyled.StyledMaterialDesignContent,
          info: notistackStyled.StyledMaterialDesignContent
        }}
      >
        <I18nextProvider i18n={i18next}>
          <AppContent />
        </I18nextProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
